import React, { useState, useContext, useEffect } from 'react'
import { defer, isFunction } from 'lodash'
import { Button } from '@mui/material'
import Dialog from './Dialog'
import ModalContext from './ModalContext'

/**
 * @typedef {import('./Dialog')} Dialog
 * @typedef {import('./Dialog').ModalProps} ModalProps
 */
/**
 * @typedef {Object} ModalState
 * @property {function} clearModal
 * @property {function} triggerModal
 * @property {function}  closeModal
 * @property {JSX.Element} modalTrigger,
 * @property {Dialog} modal
 */
/**
 * @param {ModalProps} props
 * @return {ModalState}
 */
export default function useModal({
  onClose,
  onSubmit,
  button,
  closeOnSubmit = true,
  ...modalProps
}) {
  const { activeModal, setActiveModal } = useContext(ModalContext)
  const [/** @type Dialog */ modal, setModal] = useState(null)

  const clearModal = () => {
    setModal()
    setActiveModal()
  }

  const closeModal = () => {
    // console.log('modal closing')
    clearModal()
    isFunction(onClose) && onClose()
  }

  const submitModal = () => {
    if (closeOnSubmit) {
      clearModal()
    }
    isFunction(onSubmit) && onSubmit()
  }

  /**
   *
   * @param {ModalProps=} stateOverrides
   */
  const triggerModal = (stateOverrides) => {
    setModal()
    setActiveModal()
    //const ContentComponent = modalProps.content
    // console.log('content component', ContentComponent)
    defer(() => {
      const m = (
        <Dialog {...modalProps} {...stateOverrides} onSubmit={submitModal} onClose={closeModal} />
      )
      setModal(m)
      setActiveModal(m)
      defer(() => console.log('triggerModal', { modal, activeModal, m, modalProps }))
    })
  }

  const modalTrigger = <Button onClick={triggerModal}>{button}</Button>

  // Rebuild modal on error
  useEffect(() => {
    if (modalProps.submitError) {
      triggerModal()
    }
  }, [modalProps.submitError])

  return { modal, triggerModal, closeModal, clearModal, modalTrigger }
}
